<template>
    <v-layout row wrap justify-center>
        <v-flex sm11 xs11 md11 lg11>
            <v-data-table :headers="headers" no-results-text="Nenhum registro encontrado" hide-default-footer
                :must-sort="true" :items="values" color="secondary" loading-text="Carregando registros...aguarde">
            </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>

import _ from 'lodash'

export default {
    components: {
        
    },
    data() {
        return {
            headers: [
                { text: "Motivo", value: "itemName", sortable: false},
                { text: "Quantidade", value: "qtAnimais", sortable: false },
                { text: "Percentual", value: "qtPercent", sortable: false },
            ],
        }
    },
    props:{
        values: Array,
    },
    methods: {
    },
    computed: {
    },
    mounted() {
        
    },
}
</script>

<style>
    .margingTable {
        margin-left: 1%;
        margin-right: 1%;
    }
</style>
